import Player from '@vimeo/player'

export const selector = '.tab'

export default (
    el = null
) => {
    if (!el)
        return

    console.groupCollapsed('Tab')

    const scrollTop = () => {
        el.scrollIntoView()
    }

    el.addEventListener('show.bs.tab',
        scrollTop)

    if (import.meta.hot)
        import.meta.hot
            .on('vite:beforeUpdate', () => {
                el.removeEventListener('shown.bs.tab',
                    scrollTop)
            })

    // Log els
    console.log(el)

    console.groupEnd()

    return el
}
